import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { apiClient } from '@/core/http/client';
import type { ApiError } from '@/models/apiError';
import type { components } from '@/generated/api/schema';
import { abrechnungKeys } from './abrechnung.keys';

/** Credential-presence preflight result for the caller's organization. */
export type DatextLinkoutStatus = components['schemas']['DatextLinkoutStatusResponse'];

/**
 * Fetches whether the caller's organization has DATEXT credentials on file
 * (`GET /api/v1/abrechnung/datext/status`). Cached for five minutes; pass `enabled: false` for
 * roles that are not eligible so no request is sent.
 */
export function useDatextLinkoutStatus(options: {
  enabled: boolean;
}): UseQueryResult<DatextLinkoutStatus, ApiError> {
  return useQuery({
    queryKey: abrechnungKeys.datextStatus(),
    queryFn: async (): Promise<DatextLinkoutStatus> => {
      const { data } = await apiClient.GET('/api/v1/abrechnung/datext/status');
      // The middleware throws ApiError for non-2xx responses before reaching here.
      return data as DatextLinkoutStatus;
    },
    enabled: options.enabled,
    staleTime: 5 * 60_000,
  });
}
